import React, { useContext } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Toolbar, Button, AppBar, Fab } from "@material-ui/core";
import CssBaseline from "@material-ui/core/CssBaseline";
import AddIcon from "@material-ui/icons/Add";
import HomeIcon from "@material-ui/icons/Home";
import BarChartIcon from "@material-ui/icons/BarChart";
import CategoryIcon from "@material-ui/icons/Category";
import { NavLink } from "react-router-dom";
import Modal from "@material-ui/core/Modal";
import { DataContext } from "../Context/Context";
import ModalEntries from "./Overview/ModalEntries";

const useStyles = makeStyles((theme) => ({
  offset: theme.mixins.toolbar,
  root: {
    flexGrow: 1,
    width: "100%",
    bottom: 0,
  },
  grow: {
    flexGrow: 1,
  },
  appBarBottom: {
    top: "auto",
    bottom: 0,
    marginTop: 50,
  },
  overviewIcon: {
    position: "absolute",
    bottom: 20,
    left: 40,
    color: "white",
    ["@media (min-width:1024px)"]: {
      left: 500,
    },
  },
  categoriesIcon: {
    position: "absolute",
    bottom: 20,
    left: 150,
    color: "white",
    ["@media (min-width:1024px)"]: {
      left: 650,
    },
  },
  statisticsIcon: {
    position: "absolute",
    bottom: 20,
    left: 260,
    color: "white",
    ["@media (min-width:1024px)"]: {
      left: 800,
    },
  },
  overviewTitle: {
    position: "absolute",
    bottom: -14,
    left: -18,
    fontSize: 14,
  },
  categoriesTitle: {
    position: "absolute",
    bottom: -14,
    left: -22,
    fontSize: 14,
  },
  statisticsTitle: {
    position: "absolute",
    bottom: -14,
    left: -18,
    fontSize: 14,
  },
  fabButton: {
    position: "absolute",
    zIndex: 1,
    top: -30,
    right: 20,
    margin: "0 auto",
    backgroundColor: "#04dac5",
    color: "black",
    "&:hover": {
      backgroundColor: "#04dac5",
      color: "black",
    },
  },
  activeMenu: {
    color: "#6200ee",
  },
  btnIncome: {
    color: "white",
    backgroundColor: "#6200ee",
    fontWeight: "bold",
    "&:hover": {
      backgroundColor: "#6200ee",
    },
    position: "absolute",
    bottom: 100,
    right: 40,
  },
  btnExpense: {
    color: "white",
    backgroundColor: "#6200ee",
    fontWeight: "bold",
    "&:hover": {
      backgroundColor: "#6200ee",
    },
    position: "absolute",
    bottom: 150,
    right: 40,
  },
  modal: {
    backgroundColor: "rgba(0, 0, 0, 0.1)",
  },
}));

export default function NavbarBottom(props) {
  const classes = useStyles();
  const {
    openFabModal,
    setOpenFabModal,
    setOpenEntryModal,
    setAddNewItem,
    setEditingEntry,
  } = useContext(DataContext);

  // FAB
  const handleAddNew = () => {
    setOpenFabModal(true);
  };

  const handleAddIncome = () => {
    setOpenEntryModal(true);
    setEditingEntry(false);

    setAddNewItem({
      id: new Date().valueOf(),
      type: "Income",
      cat: "",
      amount: "",
      date: new Date(),
      desc: "",
    });

    setOpenFabModal(false);
  };

  const handleAddExpense = () => {
    setOpenEntryModal(true);
    setEditingEntry(false);

    setAddNewItem({
      id: new Date().valueOf(),
      type: "Expense",
      category: "",
      amount: "",
      date: new Date(),
      desc: "",
    });
    setOpenFabModal(false);
  };

  const bodyFab = (
    <>
      <Button onClick={handleAddExpense} className={classes.btnExpense}>
        Add Expense
      </Button>
      <Button onClick={handleAddIncome} className={classes.btnIncome}>
        Add Income
      </Button>
    </>
  );

  return (
    <div>
      <React.Fragment>
        <CssBaseline />
        <AppBar position="fixed" className={classes.appBarBottom}>
          <Toolbar>
            <NavLink
              activeClassName="active"
              to="/overview"
              className={classes.overviewIcon}
            >
              <HomeIcon />
              <span className={classes.overviewTitle}>Overview</span>
            </NavLink>

            <NavLink
              to="/categories"
              className={classes.categoriesIcon}
              color="inherit"
            >
              <CategoryIcon />
              <span className={classes.categoriesTitle}>Categories</span>
            </NavLink>
            <NavLink
              to="statistics"
              className={classes.statisticsIcon}
              color="inherit"
            >
              <BarChartIcon />
              <span className={classes.statisticsTitle}>Statistics</span>
            </NavLink>
            <Fab
              color="secondary"
              aria-label="add"
              className={classes.fabButton}
              onClick={handleAddNew}
            >
              <AddIcon />
            </Fab>
          </Toolbar>
        </AppBar>
      </React.Fragment>
      <Modal
        open={openFabModal}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        className={classes.modal}
      >
        {bodyFab}
      </Modal>
      <ModalEntries />
    </div>
  );
}
